<template><div><h1 id="ereignisse-auf-fremdadressen" tabindex="-1"><a class="header-anchor" href="#ereignisse-auf-fremdadressen"><span>Ereignisse auf Fremdadressen</span></a></h1>
<p>Fremdadressereignisse — Ereignisse für Fremdadressen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Analog den Eigenadressen können auch Fremdadressen Ereignisse aufweisen. Diese werden aber in einer separaten Struktur gespeichert. Im Gegensatz zu den Eigenadressen weisen Fremdadressen aber KEINE Responseereignisse auf. Es können aber Refusé-Informationen hier gespeichert werden. Dies ist dann sinnvoll, wenn in einer künftigen Aktion dieselbe Fremdadresse wieder eingelesen würde.</p>
<p>Sobald eine Fremdadresse einen Response (Zahlungseingang) verzeichnet, wird die Adresse automatisch in die Eigenadressen übernommen.</p>
<p>Pfad: <code v-pre>Personen → Fremdadressen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Datum</dt>
<dd>Ereignisdatum</dd>
<dt>Typ/Kat.</dt>
<dd>Ereignisstatus, setzt sich zusammen aus Ereignistyp und Ereigniskategorie<br>I = Initialereignis allgemein<br>IM = Initialereignis auf Mailing<br>XU = Refusé-Ereignis, Grund unzustellbar<br>XV = Refusé-Ereignis, Grund verweigert<br>XX = Refusé-Ereignis, Grund unbekannt<br>etc.</dd>
<dt>Ereignis</dt>
<dd>Ereignisnummer</dd>
<dt>Position</dt>
<dd>Ereignisposition</dd>
<dt>Beschreibung</dt>
<dd>Ereignisbeschreibung aus Ereigniskopf</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<dl>
<dt>Ereignis-Refusé erfassen</dt>
<dd>Erfassen eines Refusé-Ereignisses. Zuerst gewünschtes Ereignis mit Pfeiltasten anwählen. Funktion wählen und die Kategorie und Datum bestätigen, bzw. anpassen.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


